import type { FeatureGroup } from '../../../types';
import { ADMINISTRATIVE_FEATURE_GROUP } from '../group';

export const ACTIVITY_FEATURE_GROUP: FeatureGroup = {
  guid: '939d0281-5204-4d6d-8eee-866f97b0ff00',
  name: 'activity',
  description: 'Account activity log — view and export user/system activity events',
  product: 'account',
  parentGuid: ADMINISTRATIVE_FEATURE_GROUP.guid,
};
